module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/framework-edc381c2c5cc4fd4f0eea7dae9ae424f.jpg";